export const PRODIGY_FILE_ENDPOINTS = {
  uploadFile: '/upload-file',
  downloadFile: '/download-file',
  uploadThumbnail: '/upload-thumb',
} as const


